// Data transformation utilities
import { AD_SIZE_PATTERNS } from '../constants';

export const getScreenSizesWithData = (config, screenSizes) => {
  if (!config || !Array.isArray(config)) return [];
  
  return config
    .filter(i => screenSizes.includes(i.name) && i.custom_fields?.find(f => f.name === 'Sizes')?.value?.length)
    .map(i => {
      const sizeField = i.custom_fields.find(f => f.name === 'Sizes');
      if (!sizeField?.type_config?.options) return null;
      
      const labelMap = Object.fromEntries(
        sizeField.type_config.options.map(opt => [opt.id, opt.label])
      );
      
      return {
        Name: i.name,
        Sizes: sizeField.value.map(id => labelMap[id]).filter(Boolean)
      };
    })
    .filter(Boolean);
};

export const getScreenSizeHasAdSize = (availableSizes) => {
  if (!availableSizes?.[0]?.custom_fields) return [];
  
  const sizesField = availableSizes[0].custom_fields.find(f => f.name === 'Sizes');
  if (!sizesField?.type_config?.options) return [];
  
  return sizesField.value
    .map(id => 
      sizesField.type_config.options.find(opt => opt.id === id)?.label
    )
    .filter(Boolean);
};

export const getFirstAvailableSize = (brandData, adSizes, screenSizeHasAdSize) => {
  if (!Array.isArray(adSizes)) return null;
  
  return adSizes.find(size => 
    brandData[size] && screenSizeHasAdSize.includes(size)
  );
};

export const getSizeToChoose = (brandData, firstAvailableSize, screenSizeHasAdSize = []) => {
  // First try to find a preferred size that's both available in brandData and for the current screen size
  for (const size of AD_SIZE_PATTERNS.PREFERRED_ORDER) {
    if (brandData[size] && screenSizeHasAdSize.includes(size)) {
      return size;
    }
  }
  // Fall back to the first available size for the current screen
  return firstAvailableSize;
};
